/** Field: the 50 px form input (handoff 4.10). A thin wrapper over Input with variant="field". */
import { forwardRef, type ReactElement } from "react";
import { Input, type InputProps } from "./Input";
export type FieldProps = Omit<InputProps, "variant">;
export const Field = forwardRef<HTMLInputElement, FieldProps>(function Field(props, ref): ReactElement { return <Input ref={ref} variant="field" {...props} />; });
